import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const PriceAmount = styled.span`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 3.2rem;
  font-weight: 500;
  line-height: 1.4;
`;

export const PriceCaption = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;
